import { render, staticRenderFns } from "./unOther.vue?vue&type=template&id=034a7c62&scoped=true&"
import script from "./unOther.vue?vue&type=script&lang=js&"
export * from "./unOther.vue?vue&type=script&lang=js&"
import style0 from "./unOther.vue?vue&type=style&index=0&id=034a7c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a7c62",
  null
  
)

export default component.exports